<template>

	<img id="imgExcelIconID"
		:src="excelIcon"
		data-tooltip="tooltip"
		@click="downloadClickFnc"
		v-if="true"
		:title="iconToolTip" 
		class="excelIconsSize"/>

</template>

<script>
import { saveAs } from "../../components/helpers/filesaver.js";
import excelIconImg from "../../assets/images/excel.png"

export default {

data() {return{

	// Color conversions
	// https://www.myfixguide.com/color-converter/
	// https://www.w3schools.com/colors/colors_picker.asp

	// ---------> API: see https://github.com/exceljs/exceljs

	// ---------- properties --------------

	//This is the data content of the spreadsheet.
	dataGrid: new Array(),

	//column keys, alignment, header row names.
	headerArray: new Array(),

	banner: 'This document contains Controlled Unclassified Information - CUI',
	tabColor:              'ff0000cc',
	tabName:               'DLA Test',
	bannerColor:           'ff005424',
	bannerTextColor:       'ffffffff',
	bodyTextColor:         'ff000000',
	headerBackgroundColor: 'ffe6ffe6',
	downloadFileName:      'spreadsheetFile.xlsx',
	iconToolTip:           'Download Spreadsheet',
	rowToFreeze:           2,
	maxCellWidth1:         120,
	maxCellWidth2:         60,
	maxCellWidth3:         30,
	minCellWidth:          10,
	cellPadding:           5,

	// ---------- spreadsheet elements --------------
	ExcelJS: null,
	workbook: null,
	worksheet: null,

	//---------- array support ---------------

	//"headerArray" records where (defaultShow == true).
	activeHeaderArray: new Array(),

	//"raw" names in "activeHeaderArray"
	activeHeaderKeys: new Array(),

	//Not currently being used.
	//Number of records in "activeHeaderArray", or 
	//length of "activeHeaderKeys".
	numTableHeaderCells: 0,
	
	//---------- icons ---------------
	excelIcon: excelIconImg,

};},

props: {

// Data = 
//   {  
//    dataGrid:   value, 
//    headerArray: value,
//   }
Data: {type: Object, require: false},

},

watch: {

Data: {
	handler: function () {
	this.dataFnc();
	},
	deep: true,
},

},

created(){
	this.$data.ExcelJS = require('exceljs');
	this.dataFnc();
},

methods: {

	tempExpirement () {
		
		let colNum = 1;
		let selectedCol = this.$data.worksheet.getColumn(colNum);

		selectedCol.eachCell((cell, rowNumber) => {
			console.log('******');
			console.log(`rowNumber[${rowNumber}]  cell[${cell._address}] = ${cell.value}`);
		});

		this.worksheet.eachRow((row, rowNumber) => {

			console.log('----------');
			console.log(`rowNumber[${rowNumber}]` );
			row.eachCell((cell, colNumber) => {
				console.log(`colNumber[${colNumber}]  cell[${cell._address}] = ${cell.value}`);
			});
		});
	},

	// ------------- Event Handling -------------------

	downloadClickFnc(){

		if (this.Data != null) {
			this.setBookProps();
			this.setSheetProps();
			this.setSheetHeaders();
			this.setSheetData();
			this.setBanner();
			this.setColWidths();
			this.adjustWidthsForBanner()
			this.setCellStyle();
			this.setAllBoders();
			this.downloadSpreadsheet();

			let debug = false;

			if (debug) {
				this.setBanner();
			}
		} else {
			let error = 'No data specified for spreadsheet.';
			this.logErrorConsoleFnc(`dataFnc(): ${error}`);
		}
	},

	// ------------- Spreadsheet Creation -------------------

	setBookProps(){
		this.$data.workbook                = new this.$data.ExcelJS.Workbook();
		this.$data.workbook.creator        = 'Dave Collins';
		this.$data.workbook.lastModifiedBy = 'Dhc';
		this.$data.workbook.created        = new Date();
		this.$data.workbook.modified       = new Date();
		this.$data.workbook.lastPrinted    = new Date();
	},

	setSheetProps() {

		this.$data.worksheet = this.$data.workbook.addWorksheet(
			this.$data.tabName, 
			{ 
			  properties:{tabColor:{argb: this.$data.tabColor}}, 
			  views: [{
					   showGridLines: true,
					   state: 'frozen', ySplit:this.$data.rowToFreeze,
					  }
					 ],
			  pageSetup:{paperSize: 9, orientation:'landscape'},
			  headerFooter: {oddFooter: "Page &P of &N", oddHeader: this.$data.banner}
			}
		);

	},

	setSheetHeaders(){

		let cols = [];
		this.$data.activeHeaderArray.forEach((rcd) => {

			let obj = {};
			obj["header"] = rcd.displayName;
			obj["key"] = rcd.rawName;
			cols.push(obj);
		});
		this.$data.worksheet.columns = cols;

	},

	setSheetData(){

		// Since the first row is a merge and uses the banner, the headers are lost from the
		// spreadsheet. So, the second row (after the banner) will act as the header row. 

		let headerRow = [];
		this.$data.activeHeaderArray.forEach((hdr) => {
			headerRow.push(hdr.displayName);
		});

		//Add header row to the worksheet.
		this.$data.worksheet.addRow(headerRow);

		//Add the data records to the worksheet.
		this.$data.dataGrid.forEach((rcd) => {
			let record = [];
			this.$data.activeHeaderKeys.forEach((key) => {
				let value = (rcd[key] == null) ? '' : rcd[key];
				record.push(value);
			});
			this.$data.worksheet.addRow(record);
		});
	},

	setBanner(){

	//this.$data.worksheet.mergeCells('A1:F1');
	//console.log('---> number of columns = ', this.$data.worksheet.columns.length);

	let numberOfColumns = this.$data.worksheet.columns.length;
	// numberOfColumns = (numberOfColumns < 6) ? 6 : numberOfColumns;

	let startRow    = 1;
	let endRow      = 1;
	let startColumn = 1;
	let endColumn   = numberOfColumns;
	this.$data.worksheet.mergeCells(startRow, startColumn, endRow, endColumn);

	//This will span all of the columns for the merged cells.
	this.$data.worksheet.getCell('A1').value = this.$data.banner;
	},
	
	setColWidths(){

		let numCols = this.$data.worksheet.columns.length;
		let mxWidth = 20;

		// console.log('numCols = ', numCols);

		if (numCols < 10) {
			mxWidth = this.$data.maxCellWidth1;
		} else if (numCols < 15) {
			mxWidth = this.$data.maxCellWidth2;
		} else {
			mxWidth = this.$data.maxCellWidth3;
		}

		// console.log('----> mxWidth = ', mxWidth);

		this.$data.worksheet.columns.forEach((column) => {

			let maxWidth = 0;

			column.eachCell((cell, rowNumber) => {

				//Skip the banner row.
				if (rowNumber > 1) {

					// console.log('cell._column._key = ', cell._column._key);

					let columnLength = cell.value ? (cell.value.toString().length) : 0;

					if (maxWidth < columnLength) {
						maxWidth = columnLength;
					}
				}

			});  //column.eachCell

			// console.log('maxWidth = ', maxWidth);

			//The padding ensures that the cell data is not squeezed into the cells.
			let colWidth = maxWidth + this.$data.cellPadding;

			//Make the width greater than or equal to the min and less than or equal to the max..
			colWidth = colWidth < this.$data.minCellWidth ? this.$data.minCellWidth: colWidth;

			colWidth = colWidth > mxWidth ? mxWidth: colWidth;

			//With meets the min and max requirements.
			column.width = colWidth;

			// console.log('---> column.width = ', column.width);

			this.alignColumn(column);
		});

	},

	adjustWidthsForBanner(){

		let bannerWidth = this.$data.banner.length + this.$data.cellPadding;
		let totalColWidths = 0;

		this.$data.worksheet.columns.forEach((column) => {
			// console.log('column.width = ',column.width);
			totalColWidths += column.width;
		});

		// console.log('-------------');

		let widthDifference = bannerWidth - totalColWidths;

		// console.log('bannerWidth     = ', bannerWidth);
		// console.log('totalColWidths  = ', totalColWidths);
		// console.log('widthDifference = ', widthDifference);

		let columnDelta = 0;
		if (widthDifference > 0) {
			let numCols = this.$data.worksheet.columns.length;
			columnDelta = Math.ceil(widthDifference/numCols);

			// console.log('numCols     = ', numCols);
			// console.log('columnDelta = ', columnDelta);
		}

		this.$data.worksheet.columns.forEach((column) => {
			column.width += columnDelta; 
		});
	},

	alignColumn(col) {

		//This aligns all cells according to the alignment specified for the data.
		//So, the banner and header will need to be aligned seperately. This is done
		//after this function call by setCellStyle().
		this.$data.activeHeaderArray.forEach((rcd) => {
			// console.log(`rcd.rawName = ${rcd.rawName}  col._key = ${col._key}`);
			if (rcd.rawName == col._key) {
				// console.log('---> rcd.dataAlignment = ',rcd.dataAlignment);
				col.alignment = {vertical: 'center', horizontal: rcd.dataAlignment, wrapText: true};
			}
		});

	},

	setCellStyle(){

		this.worksheet.eachRow((row, rowNumber) => {

			// console.log('----------');
			// console.log(`rowNumber[${rowNumber}]` );

			row.eachCell((cell) => {
				// console.log(`colNumber[${colNumber}]  cell[${cell._address}] = ${cell.value}`);
				if (rowNumber == 1) {
					this.setBannerStyle(cell);
				} else if (rowNumber == 2) {
					this.setHeaderStyle(cell);
				} 
				else {
					this.setBodyStyle(cell);
				}
			});
		});
	},

	setBannerStyle(cell) {

		let bannerColor = this.$data.bannerColor;
		let bannerTextColor = this.$data.bannerTextColor;

		cell.alignment = {vertical: 'center', horizontal: 'center', wrapText: false};

		cell.fill = {
			type: 'pattern',
			pattern:'solid',
			fgColor:{argb:bannerColor},
		};

		cell.font = {
			name: 'Calibri',
			color: { argb: bannerTextColor },
			family: 2,
			size: 14,
			bold: false,
			italic: false
		};
	},

	setHeaderStyle(cell) {

		let bdColor = this.$data.bodyTextColor;
		let headerBckColor = this.$data.headerBackgroundColor;

		let cellKey = cell._column._key;
		// console.log('setHeaderStyle() cellKey = ', cellKey);

		// cell.alignment = {vertical: 'center', horizontal: 'center',wrapText: false};

		//Set the cell's alignment using active header array.
		let length = this.$data.activeHeaderArray.length;
		for (let i = 0; i < length; i++) {
			if (cellKey == this.$data.activeHeaderArray[i].rawName) {

				let alignment = this.$data.activeHeaderArray[i].hdrAlignment;
				cell.alignment = {vertical: 'center', horizontal: alignment, wrapText: false};

				// console.log('---> rawName      = ', this.$data.activeHeaderArray[i].rawName);
				// console.log('---> alignment = ', alignment);
				break;
			}
		}

		cell.font = {
			name: 'Calibri',
			color: { argb: bdColor },
			family: 2,
			size: 14,
			bold: true,
			italic: false
		};
		cell.fill = {
			type: 'pattern',
			pattern:'solid',
			fgColor:{argb:headerBckColor},
		};

	},

	setBodyStyle(cell) {

		let bdColor = this.$data.bodyTextColor;

		//The alignment of the body data was done previously when the function
		//setColWidths() was called. It was convenient to do it then using columns.
		//     cell.alignment = {vertical: 'center', horizontal: 'center',wrapText: true};

		cell.font = {
			name: 'Calibri',
			color: { argb: bdColor },
			family: 2,
			size: 14,
			bold: false,
			italic: false
		};
	},

	setAllBoders() {

		this.worksheet.eachRow((row, rowNumber) => {

			row.eachCell((cell) => {
				// console.log(`colNumber[${colNumber}]  cell[${cell._address}] = ${cell.value}`);
				if (rowNumber >= 2) {
					cell.border = 
						{
							top: {style:'thin'},
							left: {style:'thin'},
							bottom: {style:'thin'},
							right: {style:'thin'}
						};
				}
			});
		});

	},

	async downloadSpreadsheet(){
		let fileName = this.$data.downloadFileName;
		this.$data.workbook.xlsx.writeBuffer().then(function (data) {
			var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
			saveAs(blob, fileName);
		});  		
	},

	// ------------- Watch Functions -------------------

	dataFnc() {

		if (this.Data != null) {
			try {
				this.shallowCopy_into_HeaderArray(this.Data.headerArray);
				this.setActiveHeaderArray();
				this.shallowCopy_into_dataGrid(this.Data.dataGrid);
				this.setActiveHeaderKeys();

				// console.log('ExcelComp: dataFnc(): this.Data.headerArray = ', this.Data.headerArray);
				// console.log('ExcelComp: dataFnc(): this.Data.dataGrid = ', this.Data.dataGrid);
				// console.log('ExcelComp: dataFnc(): this.$data.activeHeaderArray = ', this.$data.activeHeaderArray);
				// console.log('this.$data.numTableHeaderCells = ', this.$data.numTableHeaderCells);
				// console.log('ExcelComp: dataFnc(): this.$data.activeHeaderKeys = ', this.$data.activeHeaderKeys);

			} catch (error) {
				this.logErrorConsoleFnc(`dataFnc(): ${error}`);
			}
		}
	},

	// ------------- Array Processing -------------------

	shallowCopy_into_dataGrid(source) {

	try {
		this.$data.dataGrid = new Array();
		this.shallowCopyArray(source,this.$data.dataGrid);

	} catch (error) {
		this.logErrorConsoleFnc(`shallowCopy_into_dataGrid(): ${error}`);
	}

	},

	shallowCopy_into_HeaderArray(source) {

	try {
		this.$data.headerArray = new Array();
		this.shallowCopyArray(source,this.$data.headerArray);

	} catch (error) {
		this.logErrorConsoleFnc(`shallowCopy_into_HeaderArray(): ${error}`);
	}

	},

	shallowCopyArray(source, destination) {

	//Both arrays must exist.
	if (source && destination) {
		if (source.length > 0){

			let sourceLength = source.length;

			if (source[0] != null) {

				let keys = Object.keys(source[0]);

				if (keys.length > 0) {
					for (let i = 0; i < sourceLength; i++) {

						var obj = {};

						keys.forEach((key) => {
							obj[key] = source[i][key];
						});

						destination.push(obj);
					}
				}//if (keys.length > 0) {
			}
				
		}//if (source.length > 0){
	}//if (source && destination) {
	},

	setActiveHeaderArray(){

		try {

		// console.log('(this.$data.headerArray != null) = ', (this.$data.headerArray != null));
		// console.log('(this.$data.headerArray.length > 0)) = ', (this.$data.headerArray.length > 0));

		if ((this.$data.headerArray != null) && (this.$data.headerArray.length > 0)) {

			this.$data.activeHeaderArray = new Array();
			this.$data.numTableHeaderCells = 0;

			this.$data.headerArray.forEach((element) => {

				if (element.defaultShow == true) {

					this.$data.numTableHeaderCells++;
					let keys = Object.keys(element);

					let obj = {};
					keys.forEach((key) => {
						obj[key] = element[key];
					});

					this.$data.activeHeaderArray.push(obj);
				}
			});
		}

		} catch (error) {
		this.logErrorConsoleFnc(`${this.$data.componentName}: setActiveHeaderArray(): ${error}`);
		}
	},

	setActiveHeaderKeys() {
		this.$data.activeHeaderKeys = new Array();
		this.$data.activeHeaderArray.forEach((rcd) => {
			this.$data.activeHeaderKeys.push(rcd.rawName);
		});
		// console.log(`this.$data.activeHeaderArray = ${this.$data.activeHeaderArray}`);
		// console.log(this.$data.activeHeaderArray);
	},

	logErrorConsoleFnc(errorMsg) {
		console.error(errorMsg);
	},

},

}
</script>

<style scoped>

.excelIconsSize {
width: 28px;
height: 24px;
margin-left: 0px;
margin-right: 5px;
cursor: pointer;
}

</style>